import { FaIcon } from '@assets/icons'
import styled from 'styled-components'

export const Icon = styled(FaIcon)`
  cursor: pointer;
`
